import { SvgIcon } from "@mui/material"

import { ReactComponent as Roadwork } from "./Roadwork.svg"

export const RoadworkIcon = (props) => {
    return (
        <SvgIcon component={Roadwork} {...props} inheritViewBox />
    )
}